import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/react-loading-skeleton@3.5.0_react@19.2.1/node_modules/react-loading-skeleton/dist/index.js");
